// getTagRight
export const getHtmlTagRight = (
  str: string,
  posCloseBracket: number
): string => {
  const charEnd = str[posCloseBracket]
  if (charEnd !== '>') {
    return ''
  }

  let posOpenBracket = posCloseBracket - 1

  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (posOpenBracket < 0) {
      return ''
    }
    if (str[posOpenBracket] === '<') {
      break
    }

    posOpenBracket--
  }

  const posTagFrom = posOpenBracket + 1

  let posTagEnd = posOpenBracket + 1

  // eslint-disable-next-line no-constant-condition
  while (true) {
    posTagEnd++
    if (posTagEnd >= str.length) {
      return ''
    }
    const char = str[posTagEnd]
    if (char === '>' || !/\S/gi.test(char)) {
      break
    }
  }

  const tag = str.slice(posTagFrom, posTagEnd)

  return tag
}
